/* VitaFresh Gericht-Seite (sections/vf-gericht-main.liquid, sections/vf-gericht-empfehlungen.liquid).
   1. Grösse: Das Theme-Element <product-variants> meldet jede Wahl mit VARIANT_CHANGE
      (assets/component-product-form.js). Preis, Nährwerte und Zutatenliste sind je Variante
      serverseitig gerendert (data-vfg-v="<Varianten-ID>"); hier wird nur die passende eingeblendet.
      Knopf und Zähler der Grösse führt <vf-gericht-karte> (assets/vf-gericht-karte.js), hier nur data-aus am Feld id.
      Hat die Grösse ein eigenes Bild, zeigt die Galerie es.
   2. Nach «Jetzt bestellen!»: Das Theme (ProductForm.onSubmitHandler) hat Warenkorb-Inhalt und Zähler
      im Kopf schon aufgefrischt, bevor es add-to-cart meldet. Kein zweites refreshCart(): spart einen
      Abruf und verhindert, dass eine ältere Antwort den Nachtrag der Kühltasche überschreibt.
      Hier nur die Warenkorb-Empfehlungen neu erzeugen. Den Drawer NICHT öffnen (bewusst abgeschaltet,
      siehe component-cart.js «drawer auto-open disabled» und component-quick-buy.js).
      Den Knopftext NICHT ändern: Das sichtbare Feedback («✓ Im Warenkorb») setzt component-product-form.js
      (vfHinzugefuegt, seit 17.10.2026; vorher die App «XO Insert Code»), merkt sich den Knopftext und stellt ihn zurück;
      ein zweiter Text liess den Knopf auf «Herzlichen Dank!» stehen, rev5 H1. Unser Dank geht nur an Screenreader
      (Live-Region, visuell versteckt).
   3. Galerie: Die Bühne ist eine Wisch-Spur (scroll-snap, geht ohne JS). Die Vorschaubilder sind Sprungmarken;
      hier scrollen sie nur die Bühne (kein Seitensprung) und markieren das sichtbare Bild (aria-current).
   4. «Der Küchenchef empfiehlt»: Liefert Shopify keine Empfehlung, meldet <product-recommendations>
      product-recommendations-error; dann verschwindet die Section samt Platzhaltern.
   5. Bewertungen des Gerichts: nur unser Block (snippets/vf-rezensionen.liquid, Verhalten assets/vf-rezensionen.js), nie
      zugeklappt, der Sprung zu #vf-bewertungen braucht darum kein Skript. Judge.me ist auf der Gerichtseite seit 22.10.2026 entfernt.
   6. Neue Gerichtseite (Pasci 27.10.2026, Mockup Runde 5): Mit der Grösse wechseln auch die Zeile in «Alle Grössen je Portion»
      (data-vfg-zeile), die Variante der Saucen («+» legt den Becher der passenden Portionen-Variante, data-vfg-sauce-varianten)
      und die Grösse der Karten bei «Ähnliche Gerichte» (Radio derselben Gruppe, die Karte führt assets/vf-gericht-karte.js).
   7. Klebe-Leiste (einspaltig, unter 990 px): nur sichtbar, wenn die Kaufbox ganz nach oben aus dem Bild gescrollt ist; ihr Knopf
      sendet das Formular der Kaufbox (requestSubmit, gleiche Grösse, gleicher Weg in den Warenkorb).
   8. Foto am Computer klebt (seit 28.10.2026 statt der Kaufspalte); ist es höher als das Fenster, klebt es erst, wenn sein Ende sichtbar ist (--vfg-kleben).
   sichtbarkeit(), nachHinzufuegen(), aktiverIndex(), gruppeVon(), varianteFuerGruppe(), leisteZeigen(), leisteText() und klebeOben() sind rein
   und in Node testbar: node --test tests/vfp-gericht.test.js */
(function (root) {
  "use strict";

  var DANKE_VERZUG_MS = 100; /* Live-Regionen melden nur Änderungen: kurz leer, dann der Text */

  /* Liste aus [versteckt?] je Element für die gewählte Variante; null = nicht anfassen. */
  function sichtbarkeit(ids, gewaehlt) {
    var ziel = String(gewaehlt);
    var gibt = ids.some(function (id) { return String(id) === ziel; });
    return ids.map(function (id) { return gibt ? String(id) !== ziel : null; });
  }

  /* Was nach erfolgreichem Hinzufügen geschieht. Nie den Drawer öffnen (Entscheid VitaFresh). */
  function nachHinzufuegen(umgebung) {
    if (umgebung.warenkorbSeite) return [];
    if (umgebung.fehler) return ["meldung"]; /* z. B. 422 «nicht genug an Lager»: Hinweis zeigen, nichts überschreiben */
    var schritte = [];
    if (umgebung.hatEmpfehlungen) schritte.push("empfehlungen");
    schritte.push("danke");
    return schritte;
  }

  /* Welches Bild der Bühne sichtbar ist: Bühne scrollt in ganzen Bildbreiten. */
  function aktiverIndex(scrollLinks, breite, anzahl) {
    if (!(breite > 0) || !(anzahl > 0)) return 0;
    return Math.min(anzahl - 1, Math.max(0, Math.round(scrollLinks / breite)));
  }

  /* «id:Gruppe|id:Gruppe|…» (data-vfg-gruppen) → Gruppe der Variante, sonst "". */
  function gruppeVon(liste, id) {
    var ziel = String(id);
    var teile = String(liste || "").split("|");
    for (var i = 0; i < teile.length; i++) {
      var p = teile[i].split(":");
      if (p.length === 2 && p[0] === ziel) return p[1];
    }
    return "";
  }

  /* «Gruppe:id|…» (data-vfg-sauce-varianten) → Varianten-ID der Gruppe, sonst null (Feld bleibt, wie es ist). */
  function varianteFuerGruppe(liste, gruppe) {
    if (!gruppe) return null;
    var teile = String(liste || "").split("|");
    for (var i = 0; i < teile.length; i++) {
      var p = teile[i].split(":");
      if (p.length === 2 && p[0] === gruppe && /^\d+$/.test(p[1])) return p[1];
    }
    return null;
  }

  /* Klebe-Leiste: nur einspaltig und nur, wenn die Kaufbox nicht im Bild ist UND oberhalb liegt (schon vorbei gescrollt).
     Unterhalb (Seite eben geladen, Kaufbox noch unten) bleibt sie weg: Kaufen ist nur einmal sichtbar. Ab dem Fragen-Block
     (data-vfg-ende) wieder weg, damit sie Formular und Fusszeile nicht verdeckt (Prüfrunde 1). */
  function leisteZeigen(z) {
    return !!(z && z.einspaltig && !z.imBild && z.unten <= 0 && !z.ende);
  }

  /* Text der Klebe-Leiste: ohne Menge (oder ausverkauft) der Grundtext, sonst kurz «Noch eins (n)»,
     damit der Knopf nicht breiter wird als «In den Warenkorb» und den Preis nicht verdeckt (Prüfrunde 4). */
  function leisteText(n, grund, aus) {
    return n > 0 && !aus ? "Noch eins (" + n + ")" : (grund || "In den Warenkorb");
  }

  /* Abstand oben des klebenden Fotos (früher der Kaufspalte): normal unter dem Kopf; ist es höher als das Fenster, so weit nach oben, dass
     sein Ende mit Abstand sichtbar bleibt (negativ erlaubt). */
  function klebeOben(kopf, hoehe, fenster, abstand) {
    return Math.min(kopf + abstand, fenster - hoehe - abstand);
  }

  function zeigeBild(box, mediaId) {
    var buehne = box.querySelector(".vfp-gericht__buehne");
    var bild = buehne && mediaId != null ? buehne.querySelector('[data-vfg-media="' + String(mediaId).replace(/\D/g, "") + '"]') : null;
    if (bild) buehne.scrollTo({ left: bild.offsetLeft }); /* Bühne ist position:relative, offsetLeft zählt ab ihr */
  }

  function anwenden(box, variante) {
    if (!variante) return;
    var els = Array.prototype.slice.call(box.querySelectorAll("[data-vfg-v]"));
    var plan = sichtbarkeit(els.map(function (el) { return el.getAttribute("data-vfg-v"); }), variante.id);
    els.forEach(function (el, i) { if (plan[i] !== null) el.hidden = plan[i]; });
    /* Knopf, Text und Zähler führt <vf-gericht-karte> (assets/vf-gericht-karte.js) wie auf Karte und Quick-View: Verfügbarkeit
       als data-aus am Feld id, dann noch einmal «change» melden. Das Theme hat den Knopftext inzwischen auf seinen eigenen gesetzt. */
    var feld = box.querySelector('product-form input[name="id"]');
    if (feld) {
      if (variante.available) feld.removeAttribute("data-aus"); else feld.setAttribute("data-aus", "");
      feld.dispatchEvent(new Event("change", { bubbles: true }));
    }
    box.querySelectorAll("[data-vfg-zeile], [data-vfg-spalte]").forEach(function (el) {
      var an = (el.getAttribute("data-vfg-zeile") || el.getAttribute("data-vfg-spalte")) === String(variante.id);
      el.classList.toggle("is-gewaehlt", an);
      var hinweis = el.querySelector("[data-vfg-gewaehlt]");
      if (hinweis) hinweis.hidden = !an;
    });
    var leisteKnopf = box.querySelector("[data-vfg-leiste-knopf]");
    if (leisteKnopf) {
      leisteKnopf.disabled = !variante.available;
      if (leisteKnopf._vfgBeschriften) leisteKnopf._vfgBeschriften();
    }
    var gruppe = gruppeVon(box.getAttribute("data-vfg-gruppen"), variante.id);
    if (!gruppe) return;
    box.querySelectorAll("[data-vfg-sauce-varianten]").forEach(function (f) {
      var id = varianteFuerGruppe(f.getAttribute("data-vfg-sauce-varianten"), gruppe);
      if (id) f.value = id;
    });
    root.document.querySelectorAll("[data-vfg-aehnlich] vf-gericht-karte").forEach(function (karte) {
      var radios = Array.prototype.slice.call(karte.querySelectorAll('input[name="id"][data-groesse]'));
      var r = radios.filter(function (x) { return !x.disabled && gruppeAusName(x.getAttribute("data-groesse")) === gruppe; })[0];
      if (r && !r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  /* Grössengruppe aus dem Namen wie snippets/vf-groesse-gruppe.liquid («3 mittlere Portionen» = Mittel). */
  function gruppeAusName(name) {
    var k = String(name || "").toLowerCase();
    if (k.indexOf("klein") > -1) return "Klein";
    if (k.indexOf("mittel") > -1 || k.indexOf("mittl") > -1) return "Mittel";
    if (k.indexOf("gross") > -1) return "Gross";
    return String(name || "");
  }

  function leiste(box) {
    var el = box.querySelector("[data-vfg-leiste]");
    var kaufbox = box.querySelector("[data-vfg-kaufbox]");
    var knopf = el && el.querySelector("[data-vfg-leiste-knopf]");
    var form = box.querySelector("product-form form");
    if (!el || !kaufbox || !knopf || !form || !("IntersectionObserver" in root)) return;
    var mq = root.matchMedia("(max-width: 989px)");
    var ende = root.document.querySelector("[data-vfg-ende]");
    var letzter = null;
    var amEnde = false;
    function pruefen(e) {
      if (e) letzter = e;
      var r = letzter ? letzter.boundingClientRect : kaufbox.getBoundingClientRect();
      el.hidden = !leisteZeigen({ einspaltig: mq.matches, imBild: letzter ? letzter.isIntersecting : r.bottom > 0 && r.top < root.innerHeight, unten: r.bottom, ende: amEnde });
    }
    new root.IntersectionObserver(function (eintraege) { pruefen(eintraege[eintraege.length - 1]); }, { threshold: 0 }).observe(kaufbox);
    if (ende) new root.IntersectionObserver(function (eintraege) {
      var x = eintraege[eintraege.length - 1];
      amEnde = x.isIntersecting || x.boundingClientRect.top < 0;
      pruefen();
    }, { threshold: 0 }).observe(ende);
    if (mq.addEventListener) mq.addEventListener("change", function () { pruefen(); });
    /* Gleicher Weg wie in der Kaufbox: deren sichtbaren Knopf («In den Warenkorb» oder «+» des Zählers) auslösen, damit
       Sperre und Zähler von assets/vf-gericht-karte.js greifen (Prüfrunde 1: requestSubmit lief daran vorbei). */
    knopf.addEventListener("click", function () {
      if (knopf.disabled) return;
      var zaehler = box.querySelector("[data-vfgk-zaehler]");
      var ziel = zaehler && !zaehler.hidden ? zaehler.querySelector("[data-vfgk-plus]") : box.querySelector("[data-vfgk-korb] .vfgk__knopf");
      if (ziel && !ziel.disabled && ziel.getAttribute("aria-busy") !== "true") ziel.click();
    });
    /* Stand wie die Kaufbox (Prüfrunde 3): liegt die Grösse schon im Warenkorb, sagt die Leiste «Noch eins (n)»
       (Vorlesename «Noch eins, n im Warenkorb»),
       damit niemand unbemerkt doppelt bestellt. Quelle ist der Zähler der Kaufbox (assets/vf-gericht-karte.js). */
    var zaehler = box.querySelector("[data-vfgk-zaehler]");
    var menge = zaehler && zaehler.querySelector("[data-vfgk-menge]");
    function beschriften() {
      if (knopf._vfgOk) return;
      var n = zaehler && !zaehler.hidden && menge ? parseInt(menge.textContent, 10) : 0;
      knopf.textContent = leisteText(n, knopf.getAttribute("data-text"), knopf.disabled);
      if (n > 0 && !knopf.disabled) knopf.setAttribute("aria-label", "Noch eins, " + n + " im Warenkorb");
      else knopf.removeAttribute("aria-label");
    }
    if (zaehler && root.MutationObserver) new root.MutationObserver(beschriften).observe(zaehler, { attributes: true, attributeFilter: ["hidden"], childList: true, subtree: true, characterData: true });
    knopf._vfgBeschriften = beschriften;
    beschriften();
    box.querySelector("product-form").addEventListener("add-to-cart", function () {
      if (el.hidden || root.document.querySelector("#AjaxCartForm .alert--error")) return;
      knopf._vfgOk = true;
      knopf.textContent = "✓ Im Warenkorb";
      clearTimeout(knopf._vfg);
      knopf._vfg = setTimeout(function () { knopf._vfgOk = false; beschriften(); }, 2000);
    });
  }

  function kleben(box) {
    var foto = box.querySelector("[data-vfg-galerie]");
    if (!foto || !root.ResizeObserver) return;
    var mq = root.matchMedia("(min-width: 990px)");
    var geplant = false;
    function setzen() {
      geplant = false;
      if (!mq.matches) { foto.style.removeProperty("--vfg-kleben"); return; }
      var kopf = parseFloat(root.getComputedStyle(root.document.documentElement).getPropertyValue("--vfk-sticky")) || 0;
      foto.style.setProperty("--vfg-kleben", klebeOben(kopf, foto.offsetHeight, root.innerHeight, 16) + "px");
    }
    function planen() { if (!geplant) { geplant = true; root.requestAnimationFrame(setzen); } }
    new root.ResizeObserver(planen).observe(foto);
    root.addEventListener("resize", planen, { passive: true });
    setzen();
  }

  /* Ansage für Screenreader. Erst leeren, dann setzen: so wird auch ein zweites Bestellen wieder vorgelesen. */
  function danke(box) {
    var el = box.querySelector("[data-vfg-danke-status]");
    var danketext = box.getAttribute("data-vfg-danke");
    if (!el || !danketext) return;
    el.textContent = "";
    clearTimeout(box._vfgDanke);
    box._vfgDanke = setTimeout(function () { el.textContent = danketext; }, DANKE_VERZUG_MS);
  }

  /* Live-Region bleibt immer im DOM (leer = unsichtbar per CSS :empty), damit Screenreader die Meldung vorlesen. */
  function meldung(box, text) {
    var el = box.querySelector("[data-vfg-meldung]");
    if (el) el.textContent = (text || "").trim();
  }

  function galerie(box) {
    var buehne = box.querySelector(".vfp-gericht__buehne");
    var thumbs = Array.prototype.slice.call(box.querySelectorAll("[data-vfg-thumb]"));
    if (!buehne || thumbs.length < 2) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function (ev) {
        ev.preventDefault();
        zeigeBild(box, t.getAttribute("data-vfg-thumb"));
      });
    });
    var geplant = false;
    function markieren() {
      geplant = false;
      var i = aktiverIndex(buehne.scrollLeft, buehne.clientWidth, thumbs.length);
      thumbs.forEach(function (t, j) { if (j === i) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current"); });
    }
    buehne.addEventListener("scroll", function () {
      if (geplant) return;
      geplant = true;
      root.requestAnimationFrame(markieren);
    }, { passive: true });
  }

  /* Aussagen mit «Mehr lesen»: Den Aufklapper nur zeigen, wenn der Text die 3 Zeilen wirklich überschreitet
     (Zeichenzahl in Liquid ist nur eine Schätzung; Breite und Schrift entscheiden). Ohne JS bleibt er immer sichtbar. */
  function mehrLesen(doc) {
    var bloecke = Array.prototype.slice.call(doc.querySelectorAll(".vfp-gi__aussage--lang"));
    if (!bloecke.length) return;
    function pruefen() {
      bloecke.forEach(function (b) {
        if (b.querySelector(".vfp-gi__mehr[open]")) return;
        var t = b.querySelector(".vfp-gi__aussage-text");
        if (t) b.classList.toggle("vfp-gi__aussage--passt", t.scrollHeight <= t.clientHeight + 1);
      });
    }
    pruefen();
    if (root.ResizeObserver) new root.ResizeObserver(function () { root.requestAnimationFrame(pruefen); }).observe(doc.documentElement);
  }

  function empfehlungen(doc) {
    doc.querySelectorAll("[data-vfg-empfehlungen]").forEach(function (sec) {
      var el = sec.querySelector("product-recommendations");
      if (!el) return;
      el.addEventListener("product-recommendations-error", function () {
        var huelle = sec.closest(".shopify-section") || sec;
        huelle.hidden = true;
      });
    });
  }

  function start() {
    var doc = root.document;
    empfehlungen(doc);
    mehrLesen(doc);
    doc.querySelectorAll("[data-vfg]").forEach(function (box) {
      galerie(box);
      leiste(box);
      kleben(box);
      var pv = box.querySelector("product-variants");
      if (pv) {
        pv.addEventListener("VARIANT_CHANGE", function () {
          anwenden(box, pv.currentVariant);
          if (pv.currentVariant && pv.currentVariant.featured_media) zeigeBild(box, pv.currentVariant.featured_media.id);
        });
        if (pv.currentVariant) anwenden(box, pv.currentVariant); /* ?variant= in der URL */
      }
      var form = box.querySelector("product-form");
      if (!form) return;
      form.addEventListener("add-to-cart", function () {
        meldung(box, "");
        var alarm = doc.querySelector("#AjaxCartForm .alert--error");
        var empf = doc.querySelector("cart-recommendations");
        nachHinzufuegen({
          fehler: !!alarm,
          warenkorbSeite: doc.body.classList.contains("template-cart"),
          hatEmpfehlungen: !!(empf && typeof empf.generateRecommendations === "function" && doc.getElementById("AjaxCartForm")) /* generateRecommendations liest #AjaxCartForm */
        }).forEach(function (schritt) {
          if (schritt === "empfehlungen") empf.generateRecommendations();
          if (schritt === "danke") danke(box);
          if (schritt === "meldung") meldung(box, alarm.textContent);
        });
      });
    });
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { sichtbarkeit: sichtbarkeit, nachHinzufuegen: nachHinzufuegen, aktiverIndex: aktiverIndex, gruppeVon: gruppeVon, varianteFuerGruppe: varianteFuerGruppe, leisteZeigen: leisteZeigen, leisteText: leisteText, klebeOben: klebeOben };
  } else if (root.document) {
    if (root.document.readyState === "loading") root.document.addEventListener("DOMContentLoaded", start); else start();
  }
})(typeof window !== "undefined" ? window : globalThis);
